import React from 'react';

import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import marcas, { marcasPorId } from './marcas';

function SelectMarcaVeiculo({ value, setValue, ...props }) {
	function handleChangeSelect(_, newValue) {
		setValue(newValue?.id ?? null);
	}
	return (
		<Autocomplete
			itemID='marca-veiculo-id-item'
			id='marca-veiculo-id'
			name='marca-veiculo'
			clearText='Limpar'
			size='small'
			multiple={false}
			value={marcasPorId[value] ?? null}
			options={marcas}
			renderInput={(params) => <TextField {...params} margin='normal' label='Selecionar marca do veículo:' />}
			renderOption={(option) => option.name}
			getOptionLabel={(option) => option.name}
			onChange={handleChangeSelect}
			autoHighlight
			freeSolo
			fullWidth
			{...props}
		/>
	);
}

export default SelectMarcaVeiculo;
